var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHideField)?_c('FormulateInput',{attrs:{"value":_vm.context.model,"label":_vm.context.attributes['label-text'],"type":"select","name":"signup_to_club","options":_vm.context.options,"placeholder":"Выберите значение","validation":"required","validation-messages":{
		'required': 'выберите значение',
	}},on:{"change":(e) => _vm.$emit('input', e)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }